/**
 * True when the page is being rendered by the prerender bot (puppeteer).
 *
 * Overlays must never be baked into prerendered HTML — a static, dead cookie
 * banner shipped inside the snapshot is exactly the bug this guards against,
 * and a scroll-triggered popup would be frozen open in the same way.
 */
export function isPrerender(): boolean {
  if (typeof navigator === "undefined") return true;
  return /HeadlessChrome|Puppeteer/i.test(navigator.userAgent);
}
